<template>
	<a class="support-video-card js-video" :href="`https://www.youtube.com/watch?v=${youtubeID}`">
		<div class="support-video-card__visual-content" v-bind:class="portfolio ? `support-video-card__visual-content--${portfolio}` : ''">
			<div class="support-video-card__img-wrap">
				<img :src="thumbnailImageUrl ? thumbnailImageUrl : `https://img.youtube.com/vi/${youtubeID}/mqdefault.jpg`" alt="product image" class="support-video-card__img">
			</div>
			<div class="support-video-card__icon-opaque-circle"><i class="icon-play support-video-card__icon"></i></div>
		</div>
		<div class="support-video-card__text-content">
			<div class="support-video-card__title">{{title}}</div>
			<div class="support-video-card__description">{{videoDescription}}</div>
		</div>
	</a>
</template>

<script lang="ts">

export default {
	name: "SupportVideoCard",
	props: {
		title: {
			type: String,
			default: ""
		},
		youtubeID: {
			type: String,
			default: ""
		},
		thumbnail: {
			type: String,
			default: ""
		},
		thumbnailImageUrl: {
			type: String,
			default: ""
		},
		urlName: {
			type: String,
			default: ""
		},
		id: {
			type: String,
			default: ""
		},
		portfolio: {
			type: String,
			default: ""
		},
		productType: {
			type: String,
			default: ""
		},
		topic: {
			type: String,
			default: ""
		},
		stepId: {
			type: String,
			default: ""
		},
		videoDescription: {
			type: String,
			default: ""
		}
	},
	methods: {
		clickEvent(event) {
			
		}
	},
};
</script>
